export enum LocaleTag {
  EN = 'en',
  FR = 'fr',
  NL = 'nl',
}

export enum LocaleCode {
  EN = 'en',
  FR = 'fr',
  NL = 'nl',
}
